<app-header [user]="user()" />

<div class="www-document">
  <p align="center"><b>POLITYKA PRYWATNOŚCI</b></p>

  <p align="center"><b>L’OREAL POLSKA SP. Z O.O.</b></p>

  <p align="center"><b>POLITYKA PRYWATNOŚCI DLA KLIENTÓW KORPORACYJNYCH (B2B)</b></p>

  <p align="center">&nbsp;</p>

  <p>
    Ambicją L’Oréal jest wzorcowym przykładem społecznie odpowiedzialnego biznesu, tak aby świat uczynić piękniejszym.
    Przywiązujemy wielką wagę do uczciwości i przejrzystości oraz jesteśmy zdeterminowani, by budować z naszymi
    Klientami silne i trwałe relacje w oparciu o wzajemne zaufanie i obopólne korzyści. Jednym z przejawów tego dążenia
    jest zobowiązanie do ochrony i poszanowania ich prywatności i wyborów. Szacunek dla prywatności Klienta ma dla nas
    zasadnicze znaczenie. Dlatego też opracowaliśmy „Naszą Obietnicę Prywatności” oraz pełną Politykę Prywatności, które
    przedstawiamy poniżej.
  </p>

  <p>
    W niniejszej Polityce Prywatności przedstawiamy sposób, w jaki korzystamy z danych osobowych, które są nam
    udostępniane przez naszych Klientów działających w ramach obowiązków służbowych, np. przez salony, farmaceutów,
    sklepy detaliczne, bądź inne zainteresowane podmioty oraz przez liderów opinii.
  </p>

  <h2>Nasz obietnica prywatności</h2>

  <ol>
    <li>Szanujemy Twoją prywatność i dokonywane wybory.</li>
    <li>Dążymy do tego, by we wszystkim, co robimy, zapewniać bezpieczeństwo i prywatność.</li>
    <li>Nie będziemy sprzedawać Twoich danych osobowych.</li>
    <li>
      Jesteśmy zdeterminowani, by przechowywać Twoje dane osobowe w sposób bezpieczny. Oznacza to, że pracujemy
      wyłącznie z zaufanymi partnerami.
    </li>
    <li>
      Jesteśmy zdeterminowani, by zachować otwartość i przejrzystość co do sposobu wykorzystania Twoich danych
      osobowych.
    </li>
    <li>Nie będziemy wykorzystywać Twoich danych osobowych w sposób, o którym Cię nie poinformowaliśmy.</li>
    <li>
      Szanujemy Twoje prawa i zawsze będziemy się starać w miarę możliwości spełniać Twoje prośby, zgodnie z naszymi
      własnymi obowiązkami prawnymi i operacyjnymi.
    </li>
  </ol>

  <p>
    Poniżej przedstawiamy więcej informacji na temat naszych praktyk w zakresie prywatności, tj. rodzaje danych
    osobowych, które możemy gromadzić lub przechowywać na Twój temat, sposoby ich wykorzystania, podmioty, którym je
    udostępniamy, sposoby ich ochrony oraz zabezpieczenia, a także przysługujące Ci prawa w tym zakresie.
  </p>

  <p>
    Zwracamy uwagę, że nie wszystkie informacje podane poniżej muszą mieć do Ciebie zastosowanie. Poniżej przedstawiamy
    przegląd wszystkich możliwych sytuacji, w których może zaistnieć między nami interakcja, a jedna lub kilka z nich
    mogą mieć zastosowanie w Twoim przypadku, w zależności od sposobu kontaktowania się z nami. Przykładowo, jeżeli nie
    udostępniłeś nam fotografii dla swojego konta, wówczas te informacje nie będą mieć do Ciebie zastosowania.
  </p>

  <p>
    Gdy udostępniasz nam swoje dane osobowe lub gdy my gromadzimy dane osobowe na Twój temat, będziemy je wykorzystywać
    zgodnie z niniejszą Polityką Prywatności. Prosimy o uważnie przeczytanie tych informacji. Jeżeli masz jakieś pytania
    lub wątpliwości co do swoich danych osobowych, prosimy o kontakt z naszym Inspektorem Ochrony Danych pod
    adresem:&nbsp;<a href="mailto:personal-da@.com">personal-da&#64;.com</a>.
  </p>

  <h2>Kim jesteśmy?</h2>

  <p>
    L’Oréal prowadzi działalność w 140 krajach na całym świecie i posiada różne marki i produkty. Szczegóły na temat
    Grupy L’Oréal znajdują się pod adresem&nbsp;<a href="http://www.loreal.com/group">http://www.loreal.com/group</a>.
  </p>

  <p>
    L’Oréal Polska Sp. z o.o. jest odpowiedzialna za dane osobowe, które nam udostępniasz. Stosowane w niniejszym
    dokumencie słowa „L’Oréal”, „my”, „nas” lub „nasz” odnoszą się do tego pomiotu. L’Oréal jest „administratorem
    danych” w rozumieniu przepisów obowiązujących w zakresie ochrony danych osobowych.]
  </p>

  <p>
    <b>L’Oréal Polska Sp. z o.o.</b><br />
    Ul. Grzybowska 62<br />
    00-844 Warszawa
  </p>

  <p>
    Spółka powołała Inspektora Ochrony Danych dostępnego pod adresem:&nbsp;<a href="mailto:personal-da&#64;.com"
      >personal-da&#64;.com</a
    >
  </p>

  <h2>Czym są dane osobowe?</h2>

  <p>
    „Dane osobowe” oznaczają wszelkie informacje, które umożliwiają Twoją identyfikację albo bezpośrednio (np. Twoje
    imię i nazwisko) albo pośrednio (np. przez dane opatrzone pseudonimem, takie jak unikalny numer ID). Oznacza to, że
    dane osobowe obejmują takie elementy jak adres e-mail, adres domowy, nazwę użytkownika, zdjęcia profilowe, osobiste
    preferencje oraz zwyczaje zakupowe, treści generowane przez użytkowników, informacje finansowe oraz informacje na
    temat stanu zdrowia. Mogą także obejmować unikalny numer identyfikacyjny, taki jak adres IP Twojego komputera lub
    adres MAC Twojego urządzenia mobilnego, a także pliki cookies.
  </p>

  <p>
    Niniejsza Polityka Prywatności obejmuje wszystkie rodzaje dotyczących Cię danych osobowych, które gromadzimy i
    wykorzystujemy w L'Oréal.
  </p>

  <h2>Jakie dane osobowe gromadzimy na Twój temat oraz jak je wykorzystujemy?</h2>

  <p>
    Jako nasz Klient, jesteś w sercu naszej działalności. Bardzo się cieszymy z każdej otrzymanej od Ciebie wiadomości,
    a tworzenie i dostarczanie Ci produktów, które służą Twojemu zadowoleniu oraz rozwojowi Twojej działalności, to
    wielka przyjemność.
  </p>

  <p>Ambicją L’Oréal jest budowanie relacji w oparciu o przejrzystość i wzajemne zaufanie.</p>

  <p>
    Wiemy, że wielu spośród naszych Klientów także lubi kontakty z nami i z tego względu mogą nam udostępniać swoje dane
    osobowe na wiele sposobów, a my możemy je na wiele sposobów gromadzić.
  </p>

  <h2>W jaki sposób wykorzystujemy Twoje dane osobowe?</h2>

  <p>
    Możemy gromadzić lub otrzymywać od Ciebie dane osobowe za pomocą stron internetowych, formularzy, aplikacji,
    urządzeń, stron w mediach społecznościowych poświęconych produktom lub markom L’Oréal, podczas Twoich bezpośrednich
    interakcji z opiekunem klienta lub z zespołem obsługi klienta, bądź w jeszcze inny sposób. Czasami udostępniasz je
    nam bezpośrednio (np. kiedy tworzysz konto, gdy kontaktujesz się z nami, gdy dokonujesz zakupów przez nasze strony
    internetowe/aplikacje lub w naszych sklepach), czasami gromadzimy je (np. korzystając z plików cookies w celu
    zrozumienia, w jaki sposób korzystasz z naszych stron internetowych) lub czasami otrzymujemy Twoje dane osobowe od
    podmiotów trzecich, w tym od innych podmiotów z Grupy L’Oréal.
  </p>

  <p>
    Kiedy pobieramy dane osobowe, zaznaczamy, jakiego rodzaju dane są wymagane, za pomocą gwiazdki. Niektóre dane
    osobowe, o które Cię prosimy, są nam potrzebne w celu:
  </p>

  <ol>
    <li>
      wykonania zawartej z Tobą umowy (np. w celu utworzenia Twojego konta, dostarczenia produktów, które zakupiłeś na
      naszych stronach internetowych/w naszych aplikacjach);
    </li>
    <li>świadczenia usług, o które prosiłeś;</li>
    <li>zastosowania się do wymogów prawnych (np. fakturowanie).</li>
  </ol>

  <p>
    Jeżeli nie udostępnisz nam danych osobowych oznaczonych gwiazdką, może to mieć wpływ na towary i usługi, które
    dostarczamy.
  </p>

  <p>W poniższej tabeli wyjaśniamy:</p>

  <ol>
    <li>
      <b>Rodzaje interakcji, w ramach których możesz nam udostępniać swoje dane osobowe, a my możemy je gromadzić:</b
      >&nbsp;ta kolumna wyjaśnia rodzaj czynności lub scenariusz, które realizujesz, gdy my wykorzystujemy lub
      gromadzimy Twoje dane osobowe. Przykładowo, gdy dokonujesz zakupu, zapisujesz się do newslettera lub przeglądasz
      naszą stronę internetową.
    </li>
    <li>
      <b>Jakiego rodzaju dane osobowe możemy otrzymać od Ciebie bezpośrednio lub w wyniku Twojej interakcji z nami:</b
      >&nbsp;Ta kolumna wyjaśnia rodzaje danych osobowych, które możemy gromadzić, gdy uczestniczysz w danej czynności.
    </li>
    <li>
      <b>W jaki sposób i dlaczego wykorzystujemy Twoje dane osobowe:</b>&nbsp;Ta kolumna wyjaśnia, co robimy z Twoimi
      danymi osobowymi oraz w jakim celu je gromadzimy i wykorzystujemy.
    </li>
    <li>
      <b>Podstawy prawne wykorzystania Twoich danych osobowych.</b>&nbsp;Każdorazowo, gdy wykorzystujemy Twoje dane
      osobowe, mamy do tego stosowną podstawę prawną. Przykładowo, poprosiłeś nas o pewną usługę, udzieliłeś nam zgody
      lub mamy prawnie uzasadniony interes w wykorzystywaniu Twoich danych osobowych.
    </li>
  </ol>

  <p>Podstawą prawną przetwarzania Twoich danych osobowych może być::</p>

  <h3>
    Przegląd informacji na temat Twoich interakcji z nami oraz jakie ma to konsekwencje dla Twoich danych osobowych
  </h3>

  <p>&nbsp;</p>

  <table>
    <thead>
      <tr>
        <th>
          Rodzaje interakcji, w ramach których możesz nam udostępniać swoje dane osobowe, a my możemy je gromadzić
        </th>
        <th>
          Jakiego rodzaju dane osobowe możemy otrzymać od Ciebie bezpośrednio lub w wyniku Twojej interakcji z nami?
        </th>
        <th>W jaki sposób i dlaczego wykorzystujemy Twoje dane osobowe?</th>
        <th>Podstawy prawne wykorzystania Twoich danych osobowych</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <p><b>Tworzenie konta profesjonalnego i zarządzanie nim</b></p>

          <p>
            W przypadku gdy Twoje dane osobowe gromadzone są w ramach tworzenia profesjonalnego konta w L’Oréal lub
            zarządzania nim (albo bezpośrednio przez nasze zespoły zarządzania kontami, lub np. na stronach
            internetowych/w aplikacjach L’Oréal).
          </p>
        </td>
        <td>
          <ul>
            <li>Imię i nazwisko</li>
            <li>Płeć</li>
            <li>Adres email</li>
            <li>Adres</li>
            <li>Numer telefonu</li>
            <li>Fotografię</li>
            <li>Bank details or other financial information;</li>
            <li>Datę urodzin lub przedział wiekowy</li>
            <li>Professional account details and/or membership associations;</li>
            <li>ID, nazwę użytkownika i hasło</li>
            <li>Dane bankowe lub inne informacje finansowe;</li>
            <li>Preferencje;</li>
            <li>Profil w mediach społecznościowych (gdy stosujesz lub udostępniasz nam takie dane osobowe);</li>
            <li>Numer indetyfikacji podatkowej;</li>
            <li>Członkostwo w stowarzyszeniu zawodowym;</li>
            <li>Szkolenia (online i offline) które wybrałeś lub w których uczestniczyłeś;</li>
            <li>
              Inne informacje, które udostępniłeś nam na swój temat (np. poprzez stronę "Moje konto", przez kontakt z
              nami, pytanie za pośrednictwem funkcji "chat" dostępnej na niektórych stronach internetowych lub przez
              udział w ankiecie itp.)
            </li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>Zarządzania Twoimi zamówieniami;</li>
            <li>Zarządzania konkursami, promocjami, ankietami lub zawodami, w których zdecydujesz się wziąć udział;</li>
            <li>Udzielenia odpowiedzi na Twoje pytania lub innego rodzaju interakcje z Tobą;</li>
            <li>Zaoferowania Ci programu lojalnościowego;</li>
            <li>Umożliwienia Ci zarządzania preferencjami;</li>
            <li>
              Przesyłania Ci informacji marketingowych (jeżeli o nie prosiłeś), które mogą być dostosowane do Twojego
              „profilu” (tj. w oparciu o Twoje dane osobowe, które znamy, oraz o Twoje preferencje);
            </li>
            <li>Oferowania Ci spersonalizowanych usług w oparciu o Twoją charakterystykę urody;</li>
            <li>Monitorowania i doskonalenia naszych stron internetowych/aplikacji;</li>
            <li>Prowadzenia analiz oraz gromadzenia statystyk;</li>
            <li>Zabezpieczenia naszych stron internetowych/aplikacji oraz zapewnienia Ci ochrony przed oszustwem;</li>
            <li>Zarządzania naszą relacją z Tobą.</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>
              <b>Wykonywanie umowy.</b>&nbsp;W celu wykonania usługi, o którą prosiłeś (np. stworzenie konta,
              wypełnienie ankiety lub zakup produktu).
            </li>
          </ul>

          <ul>
            <li><b>Zgoda</b>&nbsp;na przesyłanie Ci informacji marketingowych.</li>
          </ul>

          <ul>
            <li>
              <b>Uzasadniony interes.</b>&nbsp;W zakresie zapewnienia bezpieczeństwa naszym stronom
              internetowym/aplikacjom i urządzeniom, ich ochrony przed oszustwem, a także dla lepszego zrozumienia
              Twoich potrzeb i oczekiwań i w związku z tym doskonalenia naszych usług, produktów i marek.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Subskrypcja na newsletter oraz korespondencję handlową</b></p>
        </td>
        <td>
          <ul>
            <li>Adres email</li>
            <li>Imię i nazwisko</li>
            <li>Preferencje;</li>
            <li>
              Profil w mediach społecznościowych (gdy stosujesz social login lub gdy udostępniasz nam takie dane
              osobowe);
            </li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>
              Przesyłania Ci informacji marketingowych (jeżeli o nie prosiłeś), które mogą być dostosowane do Twojego
              „profilu” w oparciu o Twoje dane osobowe, które znamy, oraz o Twoje preferencje (w tym lokalizację Twojego
              ulubionego sklepu);
            </li>
            <li>Prowadzenia analiz oraz gromadzenia statystyk;</li>
            <li>
              Prowadzenia aktualnej listy adresów wyłączonych z korespondencji, gdy poprosisz o zaprzestanie przesyłania
              Ci takiej korespondencji.
            </li>
          </ul>
        </td>
        <td>
          <ul>
            <li><b>Zgoda</b>&nbsp;Na przesyłanie Ci informacji w ramach marketingu bezpośredniego.</li>
          </ul>

          <ul>
            <li>
              <b>Uzasadniony interes:</b>&nbsp;W celu dostosowania naszych informacji handlowych, zrozumienia ich
              efektywności oraz zapewnienia Ci najbardziej adekwatnego doświadczenia; abyśmy mogli lepiej zrozumieć
              Twoje potrzeby i oczekiwania i w związku z tym doskonalić nasze usługi, produkty i marki.
            </li>
          </ul>

          <ul>
            <li>
              <b>Podstawa prawna:</b>&nbsp;W celu zachowania Twoich danych na liście adresów wyłączonych z
              korespondencji, jeśli poprosiłeś o nieprzesyłanie korespondencji w ramach marketingu bezpośredniego.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Zakupy i zarządzanie zamówieniami</b></p>

          <p>
            Informacje gromadzone podczas procesu zakupów dokonywanych w L’Oréal lub podczas naszych interakcji np. na
            naszej stronie internetowej/w naszej aplikacji/na stronach społeczościowych lub w sklepie.
          </p>
        </td>
        <td>
          <ul>
            <li>Imię i nazwisko;</li>
            <li>Adres email;</li>
            <li>Adres (dostawa i fakturowanie);</li>
            <li>Numer telefonu;</li>
            <li>Opis osoby oraz preferencji;</li>
            <li>
              Profil w mediach społecznościowych (gdy stosujesz social login lub udostępniasz nam takie dane osobowe);
            </li>
            <li>Informacje na temat transakcji w tym zakupionych produktów oraz lokalizacji sklepu;</li>
            <li>Informacje na temat płatności lub</li>
            <li>Historia zakupów.</li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>
              Skontaktowania się z Tobą w celu finalizacji zamówienia, jeżeli zapisałeś swój koszyk zakupowy lub
              umieściłeś w nim produkty bez ukończenia procesu zamówienia;
            </li>
            <li>Informowania Cię, gdy żądany produkt będzie dostępny;</li>
            <li>Przetwarzania i realizacji Twojego zamówienia, w tym dostawy produktu na wskazany adres;</li>
            <li>
              Zarządzania płatnością za Twoje zamówienie. Na marginesie informujemy, że informacje na temat płatności
              (numer karty kredytowej / informacje Paypal / dane rachunku bankowego) nie są gromadzone przez nas, lecz
              przez dostawców usług płatniczych;
            </li>
            <li>Zarządzania kontaktami, które nawiązują Państwo z nami w związku ze swoim zamówieniem;</li>
            <li>
              Zabezpieczenia transakcji przed oszustwem. Przy okazji informujemy, że korzystamy z rozwiązania podmiotu
              zewnętrznego w celu wykrywania oszustw oraz zapewnienia kompletnej płatności dokonywanej przez Ciebie lub
              osoby przez Ciebie upoważnione;
            </li>
            <li>Wzbogacenia Twojego profilu, gdy dokonujesz zakupu z wykorzystaniem informacji ze swojego konta;</li>
            <li>Pomiaru satysfakcji;</li>
            <li>Zarządzania ewentualnymi sporami związanymi z zakupami;</li>
            <li>W celach statystycznych.</li>
          </ul>
        </td>
        <td>
          <ul>
            <li><b>Wykonywanie umowy</b>&nbsp;W celu wykonania zamówionej usługi (zakupu).</li>
          </ul>

          <ul>
            <li>
              <b>Uzasadniony interes:</b>&nbsp;W celu zabezpieczenia Ciebie i nas przed transakcjami oszukańczymi oraz
              zapewnienia, by płatności były kompletne i wolne od oszustwa i sprzeniewierzenia.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Przeglądanie treści internetowych</b></p>

          <p>
            Informacje gromadzone za pomocą plików cookies lub podobnych technologii („Pliki Cookies”*), gdy przeglądasz
            strony internetowe/aplikacje L’Oréal oraz innych podmiotów.
          </p>

          <p>
            Informacje na temat konkretnych Plików Cookies umieszczanych na danej stronie internetowej/aplikacji
            znajdują się w odpowiedniej tabeli dotyczącej plików cookies.
          </p>

          <p>
            <small
              >*Pliki Cookies to małe pliki tekstowe przechowywane na Twoim urządzeniu (komputer, tablet lub telefon
              komórkowy) gdy korzystasz z Internetu, m.in. gdy odwiedzasz strony internetowe Grupy L’Oreal.</small
            >
          </p>
        </td>
        <td>
          <p>W zależności od intensywności Twoich interakcji z nami, może to obejmować:</p>

          <ul>
            <li>Dane związane z Twoim korzystaniem z naszych stron internetowych/aplikacji:</li>
            <li>Strona, z której zostałeś przekierowany na daną stronę;</li>
            <li>Dane dotyczące logowania;</li>
            <li>Strony, które odwiedzałeś;</li>
            <li>Filmy, które oglądałeś;</li>
            <li>Reklamy, w które klikasz lub stukasz;</li>
            <li>Produkty, których szukasz;</li>
            <li>Twoja lokalizacja;</li>
            <li>Czas trwania wizyty;</li>
            <li>Produkty, które wybrałeś w celu stworzenia koszyka.</li>
          </ul>

          <p>Informacje techniczne:</p>

          <ul>
            <li>Adres IP;</li>
            <li>Dane przeglądarki;</li>
            <li>Informacje na temat urządzenia.</li>
          </ul>

          <p>
            Unikalny identyfikator przypisany do każdego odwiedzającego oraz data wygaśnięcia takiego identyfikatora.
          </p>
        </td>
        <td>
          <p>
            Wykorzystujemy Pliki Cookies tam, gdzie jest to odpowiednie, z innymi danymi osobowymi, które już nam
            udostępniłeś (takie jak poprzednie zakupy, albo czy zapisałeś się na nasze newslettery e-mailowe) lub
            następujące cele:
          </p>

          <ul>
            <li>
              W celu umożliwienia prawidłowego funkcjonowania naszej strony internetowej/aplikacji:
              <ul>
                <li>prawidłowe wyświetlanie treści;</li>
                <li>tworzenie i zapamiętywanie koszyka;</li>
                <li>tworzenie i zapamiętywanie Twojego loginu;</li>
                <li>personalizacja interfejsu jak np. języka;</li>
                <li>parametry przypisane do Twojego urządzenia, w tym rozdzielczość ekranu itp.;</li>
                <li>
                  doskonalenie naszych stron internetowych/aplikacji, na przykład przez testowanie nowych pomysłów.
                </li>
              </ul>
            </li>
            <li>
              W celu zapewnienia bezpieczeństwa strony internetowej /aplikacji oraz ochrony użytkownika przed oszustwem
              i niewłaściwym użyciem naszych stron internetowych lub usług, np. przez wykonywanie diagnostyki.
            </li>
            <li>
              W celu prowadzenia statystyki:
              <ul>
                <li>W celu uniknięcia podwójnego liczenia odwiedzających;</li>
                <li>W celu poznania reakcji użytkowników na nasze kampanie reklamowe;</li>
                <li>W celu doskonalenia naszych ofert;</li>
                <li>W celu poznania, w jaki sposób, odkryłeś nasze strony internetowe/aplikacje.</li>
              </ul>
            </li>
            <li>
              W celu dostarczania reklamy behawioralnej online:
              <ul>
                <li>
                  W celu przedstawiania Ci reklam online dotyczących produktów, które mogą Cię interesować,w oparciu o
                  Twoje dotychczasowe zachowanie;
                </li>
                <li>W celu prezentacji reklam i treści na platformach mediów społecznościowych.</li>
              </ul>
            </li>
            <li>
              W celu dostosowania naszych usług do Ciebie:
              <ul>
                <li>
                  W celu przesyłania Ci rekomendacji, marketingu lub treści w oparciu o Twój profil i zainteresowania;
                </li>
                <li>
                  W celu wyświetlania naszych stron internetowych/aplikacji w sposób dostosowany na podstawie
                  zapamiętanych informacji o Twoim koszyku, loginie, języku, plików cookies dotyczących personalizacji
                  interfejsu użytkownika (tj. parametrów związanych z Twoim urządzeniem, w tym rozdzielczość ekranu,
                  preferencje dotyczące czcionki itd.).
                </li>
              </ul>
            </li>
            <li>
              W celu umożliwienia udostępniania naszych treści w mediach społecznościowych (udostępnianie przycisków
              służących wyświetlaniu strony).
            </li>
          </ul>
        </td>
        <td>
          <ul>
            <li>
              <b>Uzasadniony interes:</b>&nbsp;W celu zapewnienia Ci stron internetowych / aplikacji, reklam i
              komunikacji, które prawidłowo funkcjonują oraz nieustannie się doskonalą pod względem plików cookies,
              które są (i) zasadnicze dla funkcjonowania naszych stron internetowych/aplikacji, (ii) używane w celu
              zachowania bezpieczeństwa naszych stron internetowych/aplikacji.
            </li>
            <li><b>Zgoda</b>Na wszystkie pozostałe pliki cookies.</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Działania promocyjne</b></p>

          <p>Informacje gromadzone podczas gry, konkursów, ofert promocyjnych, próśb o przesłanie próbek, ankiet.</p>
        </td>
        <td>
          <p>W zależności od intensywności Twoich interakcji z nami, może to obejmować:</p>

          <ul>
            <li>Imię i nazwisko;</li>
            <li>Adres email;</li>
            <li>Numer telefonu;</li>
            <li>Datę urodzenia;</li>
            <li>Płeć;</li>
            <li>Adres;</li>
            <li>Opis osoby oraz preferencji;</li>
            <li>
              Profil w mediach społecznościowych (gdy stosujesz social login lub udostępniasz nam takie dane osobowe);
            </li>
            <li>
              Inne informacje, które udostępnili nam Klienci na swój temat (np. poprzez stronę „Moje konto”, przez
              kontakt z nami, przez udostępnienie nam własnych treści takich jak fotografie lub przegląd, pytanie za
              pośrednictwem funkcji „chat” dostępnej na niektórych stronach internetowych/w niektórych aplikacjach lub
              przez udział w konkursie, grze, ankiecie itp.).
            </li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>
              Wykonania zadań, o które nas poprosiłeś, np. w celu zarządzania Twoim udziałem w konkursach, grach i
              ankietach, w tym w celu uwzględnienia Twoich informacji zwrotnych i sugestii;
            </li>
            <li>W celach statystycznych;</li>
            <li>Przesyłanie informacji marketingowych (jeżeli nas o to poprosiłeś).</li>
          </ul>
        </td>
        <td>
          <ul>
            <li><b>Wykonywanie umowy</b>&nbsp;W celu wykonania usługi, o którą prosiłeś.</li>
            <li>
              <b>Uzasadniony interes:</b>&nbsp;Abyśmy mogli lepiej zrozumieć Twoje potrzeby i oczekiwania i w związku z
              tym doskonalić nasze usługi, produkty i marki.
            </li>
            <li><b>Zgoda:</b>&nbsp;Na przesyłanie Ci informacji marketingowych.</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Treści generowane przez użytkownika</b></p>

          <p>
            Informacje gromadzone w przypadku gdy przekazałeś nam pewne treści na jednej z naszych platform
            społecznościowych lub udzieliłeś nam zgody na ponowne wykorzystanie umieszczanych przez Ciebie treści na
            platformach mediów społecznościowych.
          </p>
        </td>
        <td>
          <p>&nbsp;</p>
          W zależności od intensywności Twoich interakcji z nami, może to obejmować:

          <p>&nbsp;</p>

          <ul>
            <li>Imię i nazwisko lub pseudonim;</li>
            <li>Adres email;</li>
            <li>Fotografię;</li>
            <li>Opis osoby oraz preferencji;</li>
            <li>
              Profil w mediach społecznościowych (gdy stosujesz social login lub udostępniasz nam takie dane osobowe);
            </li>
            <li>
              Inne informacje, które udostępniłeś nam na swój temat (np. poprzez stronę „Moje konto”, przez kontakt z
              nami, przez udostępnienie nam własnych treści, takich jak fotografie lub recenzje, pytanie za
              pośrednictwem funkcji „chat” dostępnej na niektórych stronach internetowych/w niektórych aplikacjach).
            </li>
          </ul>
        </td>
        <td>
          <p>Zgodnie z konkretnymi warunkami, na które wyraziłeś zgodę:</p>

          <ul>
            <li>W celu umieszczenia Twoich recenzji lub treści;</li>
            <li>W celu promowania naszych produktów.</li>
            <li>W celach statystycznych.</li>
          </ul>
        </td>
        <td>
          <ul>
            <li><b>Zgoda</b>&nbsp;Na ponowne wykorzystanie treści umieszczonych przez Ciebie online.</li>
            <li>
              <b>Uzasadniony interes:</b>Abyśmy mogli lepiej zrozumieć Twoje potrzeby i oczekiwania i w związku z tym
              doskonalić i promować nasze usługi, produkty i marki.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Wykorzystanie Aplikacji i urządzeń</b></p>

          <p>Informacje gromadzone w ramach korzystania przez Ciebie z naszych aplikacji lub urządzeń.</p>
        </td>
        <td>
          <p>W zależności od intensywności Twoich interakcji z nami, może to obejmować:</p>

          <ul>
            <li>Imię i nazwisko;</li>
            <li>Adres email;</li>
            <li>Lokalizację;</li>
            <li>Datę urodzenia;</li>
            <li>Opis osoby oraz preferencji;</li>
            <li>Fotografię;</li>
            <li>Profil urody, w tym odcień skóry, rodzaj skóry/włosów;</li>
            <li>Położenie geograficzne.</li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>
              Wykonania zamówionej przez Ciebie usługi (np. wirtualne testowanie naszych produktów, kupowanie naszych
              produktów przez aplikację lub na odpowiednich stronach handlu elektronicznego; porady oraz powiadomienia
              dotyczące Twojej ekspozycji na słońce, codziennej pielęgnacji włosów);
            </li>
            <li>
              Analizy Twojego profilu urody oraz zarekomendowania odpowiednich produktów (w tym produktów na zamówienie)
              oraz praktyk pielęgnacyjnych;
            </li>
            <li>Przedstawienia Ci rekomendacji na temat produktów i praktyk pielęgnacyjnych;</li>
            <li>W celach badawczych i innowacyjnych realizowanych przez naukowców z Grupy L’Oréal;</li>
            <li>W celu monitorowania i doskonalenia naszych Aplikacji i urządzeń;</li>
            <li>W celach statystycznych.</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>
              <b>Wykonywanie umowy</b>&nbsp;W celu wykonania żądanej usługi (w tym, w razie potrzeby, analizy dokonanej
              przez zespół badawczo-innowacyjny algorytmu niezbędnego do wykonania usługi).
            </li>
            <li>
              <b>Uzasadniony interes:</b>W celu ciągłego doskonalenia naszych produktów i usług, aby odpowiedzieć na
              Twoje potrzeby i oczekiwania, a także dla celów badań naukowych oraz innowacji.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Zapytania</b></p>

          <p>
            Informacje gromadzone, gdy zadajesz pytania (np. poprzez naszą obsługę Klienta) dotyczące naszych marek,
            produktów oraz ich użytkowania.
          </p>
        </td>
        <td>
          <p>W zależności od intensywności Twoich interakcji z nami, może to obejmować:</p>

          <ul>
            <li>Imię i nazwisko;</li>
            <li>Numer telefonu;</li>
            <li>Adres email;</li>
            <li>
              Inne informacje, które nam udostępniłeś na swój temat w związku ze swoim zapytaniem (które mogą obejmować
              dane na temat stanu zdrowia oraz dobrostanu).
            </li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>Udzielenia odpowiedzi na Twoje pytania;</li>
            <li>W razie potrzeby, skontaktowania Cię z odpowiednimi służbami;</li>
            <li>W celach statystycznych;</li>
            <li>
              Dla celów nadzoru nad bezpieczeństwem produktów kosmetycznych:
              <ul>
                <li>
                  W celu monitorowania i zapobiegania ewentualnych działań niepożądanych związanych z używaniem naszych
                  produktów;
                </li>
                <li>W celu prowadzenia badań dotyczących bezpiecznego używania naszych produktów;</li>
                <li>W celu podejmowania ewentualnych działań korygujących w razie potrzeby i ich kontynuacji.</li>
              </ul>
            </li>
          </ul>
        </td>
        <td>
          <ul>
            <li><b>Wykonywanie umowy</b>&nbsp;W celu przetwarzania prośby.</li>
            <li><b>oraz</b></li>
            <li><b>Uzasadniony interes</b>W celu skontaktowania się z daną osobą na prośbę innej osoby.</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Imprezy, seminaria oraz sesje szkoleniowe</b></p>

          <p>
            W przypadku gdy kontaktujesz się z nami podczas wykonywania swoich obowiązków służbowych jako nasz Klient,
            sprzedawca, usługodawca, dziennikarz itp.
          </p>
        </td>
        <td>
          <ul>
            <li>Imię i nazwisko;</li>
            <li>Nazwa organizacji;</li>
            <li>Płeć;</li>
            <li>Data urodzenia;</li>
            <li>Zawód;</li>
            <li>Służbowy lub prywatny adres email;</li>
            <li>Adres służbowy lub prywatny;</li>
            <li>Służbowy lub prywatny numer telefonu;</li>
            <li>Umiejętności zawodowe i techniczne;</li>
            <li>Fotografia;</li>
            <li>Preferencje;</li>
            <li>Używany język;</li>
            <li>Inne informacje, które nam udostępniłeś na swój temat.</li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>
              Przesłania Ci zaproszenia, zorganizowania odpowiednich imprez, seminariów, które organizujemy w ramach
              naszej działalności gospodarczej;
            </li>
            <li>
              Przekazania Ci informacji oraz zapewnienia szkoleń na temat naszych produktów, usług i marek,
              dostosowanych do Twojego profesjonalnego profilu.
            </li>
          </ul>
        </td>
        <td>
          <ul>
            <li>
              <b>Wykonywanie umowy,</b>&nbsp;W celu wykonania żądanej usługi dla Ciebie lub na rzecz Twojej organizacji.
            </li>
            <li>
              <b>Nasz uzasadniony interes</b>&nbsp;W celu skontaktowania się z Tobą w sprawie naszych produktów i usług;
              doskonalenia naszych produktów i usług lub zapewnienia Ci lepszej obsługi.
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <p><b>Obsługa naszych interesariuszy (w tym liderów opinii)</b></p>

          <p>W przypadku gdy dla zapewnienia Ci lepszej obsługi niezbędne jest przetwarzanie Twoich danych osobowych</p>
        </td>
        <td>
          <p>
            Dane osobowe udostępnione przez Ciebie publicznie w sposób ewidentny, takie jak treść Twojego profilu
            publicznego, recenzje lub fotografie, które udostępniasz, dotyczące Cię informacje zawarte w publicznie
            dostępnych źródłach, takich jak relacje w mediach. Może to obejmować:
          </p>

          <ul>
            <li>Imię i nazwisko, pseudonim;</li>
            <li>Płeć;</li>
            <li>Adres email;</li>
            <li>Adres;</li>
            <li>Numer telefonu;</li>
            <li>Dane banku lub inne informacje finansowe;</li>
            <li>Fotografię;</li>
            <li>ID, nazwę użytkownika i hasło;</li>
            <li>Preferencje;</li>
            <li>Treści generowane przez użytkownika (takie jak recenzje lub udostępniane przez Ciebie fotografie);</li>
            <li>Inne informacje, które nam udostępniłeś na swój temat.</li>
          </ul>
        </td>
        <td>
          <p>W celu:</p>

          <ul>
            <li>Zarządzania naszymi zobowiązaniami w zakresie zgodności z przepisami prawa;</li>
            <li>Przeanalizowania Twojego profilu pod kątem dostosowania do naszych wartości;</li>
            <li>Zarządzanie naszymi relacjami.</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>
              <b>Podstawa prawna:</b>&nbsp;W celu wywiązania się z naszego zobowiązania ustawowego w zakresie zwalczania
              korupcji, zapobiegania praniu brudnych pieniędzy oraz finansowaniu terroryzmu, zgodności z przepisami
              dotyczącymi sankcji oraz embarga, zwalczania oszustw podatkowych.
            </li>
            <li>
              <b>Uzasadniony interes:</b>&nbsp;W przypadku gdy podejmiemy decyzję współpracy z Tobą nad danym projektem
              lub działaniem. W przypadku liderów opinii: przykładowo, oceniamy, czy treści umieszczone przez nich na
              profilach w mediach społecznościowych oraz publiczne dane na ich temat są zgodne z naszymi wartościami
              wymienionymi w naszej Karcie Wartości Liderów Opinii (Influencer Value Charter). Nasz uzasadniony interes
              polega także na upewnieniu się, czy nie kupują oni ani nie zwiększają sztucznie liczby obserwacji np.
              przez ich kupowanie lub na zasadzie „like za like”.
            </li>
            <li><b>Wykonywanie umowy</b>W przypadku gdy nasze relacje oparte są o zawartą z partnerem umowę.</li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>

  <h2>Zautomatyzowane podejmowanie decyzji</h2>

  <p>
    W celu zabezpieczenia transakcji realizowanych przez nasze strony internetowe/aplikacje/urządzenia przed oszustwem i
    sprzeniewierzeniem korzystamy z rozwiązań dostawców zewnętrznych. Wykrywanie oszustw obejmuje m.in. czynności
    prostego porównywania, wyszukiwania asocjacji, grupowania, przewidywania oraz wykrywania odchyleń przy użyciu
    inteligentnych agentów, technik łączenia danych oraz różnego rodzaju technik eksploracji danych.
  </p>

  <p>
    Proces wykrywania oszustw może być całkowicie zautomatyzowany lub może wiązać się z udziałem człowieka, w przypadku
    gdy to on podejmuje ostateczną decyzję. W każdym przypadku jednak podejmujemy wszelkie racjonalne środki ostrożności
    i zabezpieczenia, by ograniczyć dostęp do Twoich danych.
  </p>

  <p>
    W związku z automatycznym wykrywaniem oszustw, (i) Twoje zamówienia/prośby mogą być przetwarzane z opóźnieniem,
    jeżeli dana transakcja jest akurat przez nas sprawdzana; oraz (ii) Twój dostęp do danej usługi może być ograniczony
    lub niemożliwy, jeżeli zostanie wykryte ryzyko oszustwa. Przysługuje Ci prawo dostępu do informacji, na których
    opieramy taką decyzję. Prosimy o sprawdzenie części „Twoje prawa i wybory” poniżej.
  </p>

  <h2>Profilowanie</h2>

  <p>
    W przypadku gdy wysyłamy lub wyświetlamy treści lub wiadomości spersonalizowane, możemy korzystać z technik takich
    jak „profilowanie” (tj. wszelkie formy zautomatyzowanego przetwarzania danych osobowych polegające na wykorzystaniu
    takich danych w celu oceny czynników osobowych osoby fizycznej, w szczególności w celu analizowania lub
    prognozowania aspektów dotyczących osobistych preferencji osoby fizycznej, jej zainteresowań, sytuacji ekonomicznej,
    zachowania, lokalizacji, zdrowia, wiarygodności lub przemieszczania się). Oznacza to, że możemy gromadzić dane
    osobowe użytkownika w poszczególnych scenariuszach wymienionych w powyższej tabeli. Dokonujemy centralizacji takich
    danych i analizujemy je, aby ocenić i prognozować Twoje osobiste preferencje lub zainteresowania.
  </p>

  <p>
    W oparciu o takie analizy, przesyłamy lub wyświetlamy wiadomości lub treści dostosowane do Twoich
    zainteresowań/potrzeb.
  </p>

  <p>
    W pewnych okolicznościach przysługuje Ci prawo sprzeciwu wobec używania Twoich danych do profilowania. Prosimy o
    sprawdzenie części „Twoje prawa i wybory” poniżej.
  </p>

  <h2>Kto ma dostęp do Twoich danych osobowych?</h2>

  <p>
    <b
      >Twoje dane osobowe możemy udostępniać w ramach Grupy L’Oréal w celu wywiązania się z naszych zobowiązań
      ustawowych, w celu zapobiegania oszustwom lub zabezpieczenia naszych narzędzi, doskonalenia naszych produktów lub
      usług lub po uzyskaniu Twojej zgody.</b
    >
  </p>

  <p>
    W zależności od celów, w jakich Twoje dane osobowe zostały zgromadzone oraz wyłącznie w przypadkach, gdy jest to
    niezbędne, do niektórych z nich mogą mieć dostęp podmioty z Grupy L’Oréal z całego świata, w miarę możliwości w
    postaci spseudonimizowanej (uniemożliwiającej bezpośrednią identyfikację), a także gdy jest to niezbędne w celu
    wykonania żądanych przez Ciebie usług.
  </p>

  <p>
    Możemy także udostępniać Twoje dane osobowe w postaci spseudonimizowanej (uniemożliwiającej bezpośrednią
    identyfikację) naukowcom z pionu Badań Naukowych oraz Innowacji L’Oréal, m.in. pracującym w innych krajach, w celu
    prowadzenia badań naukowych i innowacji.
  </p>

  <p>
    W dozwolonych przypadkach, możemy także udostępniać niektóre z Twoich danych osobowych, w tym te, które gromadzimy
    za pomocą plików cookies pomiędzy naszymi markami w celu harmonizacji i aktualizacji informacji, które otrzymujemy
    od Ciebie, w celu prowadzenia statystyk w oparciu o Twoją charakterystykę oraz w celu dostosowania wysyłanej przez
    nas korespondencji.
  </p>

  <p>
    Więcej informacji na temat Grupy Grupy L’Oréal, jej marek oraz lokalizacji znajduje się na naszej stronie
    internetowej.
  </p>

  <p>
    <b
      >Możemy udostępniać Twoje dane osobowe podmiotom zewnętrznym lub podmiotom z Grupy L’Oréal w celach
      marketingowych.</b
    >
  </p>

  <p>
    Do celów marketingu bezpośredniego Twoje dane osobowe udostępniamy podmiotom zewnętrznym tylko za Twoją zgodą. W
    takim przypadku Twoje dane osobowe są przetwarzane przez podmioty zewnętrzne działające w charakterze administratora
    danych i wtedy mają zastosowanie ich własne warunki oraz polityka prywatności. Powinieneś dokładnie sprawdzić
    dokumentację takich podmiotów zanim udzielisz zgody na ujawnienie im swoich informacji.
  </p>

  <p>
    <b>Twoje dane osobowe mogą być także przetwarzane w naszym imieniu przez zaufanych usługodawców zewnętrznych.</b>
  </p>

  <p>
    Szereg operacji biznesowych zlecamy naszym zaufanym kontrahentom zewnętrznym. Udostępniamy im tylko takie
    informacje, które muszą posiadać, by wykonać daną usługę, a my zobowiązujemy ich do niewykorzystywania Twoich danych
    osobowych do innych celów. Zawsze staramy się zapewniać, by wszyscy nasi zewnętrzni współpracownicy przechowywali
    Twoje dane osobowe w sposób bezpieczny. Przykładowo, możemy powierzać usługi niezbędne w celu przetwarzania Twoich
    danych osobowych:
  </p>

  <p>
    Podstawą prawną takiego udostępniania jest nasz uzasadniony interes – (i) w doskonaleniu naszych produktów i usług;
    (ii) w lepszej obsłudze klienta; (iii) w zapobieganiu oszustw; (iv) w zabezpieczaniu narzędzi oraz projektowaniu
    nowych elementów; (v) korzystaniu z odpowiednich dostawców; oraz (vi) w zapewnieniu, by wartości użytkownika były
    zgodne z wartościami L’Oréal.
  </p>

  <p><b>Możemy także udostępniać Twoje dane osobowe podmiotom zewnętrznym:</b></p>

  <p><b>Możemy także udostępniać Twoje dane osobowe naszym partnerom:</b></p>

  <p>
    W przypadku gdy usługa, którą subskrybujesz, została stworzona wspólnie przez L’Oréal i naszego partnera (np.
    aplikacja firmowana przez dwa podmioty). W takim przypadku, zarówno L’Oréal, jak i partner przetwarza Twoje dane
    osobowe dla swoich własnych celów i w związku z tym, Twoje dane są przetwarzane:
  </p>

  <p>
    W przypadku gdy wyraziłeś zgodę na otrzymywanie informacji marketingowych i handlowych od partnera L’Oréal poprzez
    zaznaczenie odpowiedniego okienka opcji (np. przez aplikację firmowaną przez L’Oréal i udostępnioną partnerom). W
    takim przypadku Twoje dane są przetwarzane przez partnera działającego także jako administrator danych zgodnie z
    jego własnymi warunkami oraz zgodnie z jego polityką prywatności.
  </p>

  <p>
    Możemy publikować treści z sieci społecznościowych na naszych nośnikach. W przypadku gdy przeglądasz treści z sieci
    społecznościowych na naszych stronach internetowych/w naszych aplikacjach, na Twoim urządzeniu może być
    przechowywany plik cookie z takiej sieci społecznościowej. Więcej informacji na ten temat znajduje się w naszej
    Polityce Plików Cookie dotyczącej takich sieci społecznościowych - zapraszamy do zapoznania się z nią;
  </p>

  <p>
    W przypadku gdy będziemy korzystać z usług reklamowych Google na naszych stronach internetowych/w naszych
    aplikacjach, Google będzie mieć dostęp do Twoich danych osobowych i będzie je wykorzystywać. Więcej informacji na
    temat sposobu wykorzystywania Twoich danych osobowych przez Google w tym kontekście znajduje się w ich polityce i
    warunkach prywatności Google Privacy &amp; Terms, które mają zastosowanie do takich usług i przetwarzania danych.
  </p>

  <p><b>Informacje, które gromadzi i udostępnia nam Facebook</b></p>

  <p>
    Wszystkie funkcje i usługi Facebooka dostępne na naszej stronie internetowej/w naszej aplikacji uregulowane są w
    stosownej polityce pt. Facebook Data Policy, w której można znaleźć więcej informacji na temat praw przysługujących
    użytkownikom w zakresie prywatności oraz opcji ustawień.
  </p>

  <p>Korzystając z tej strony internetowej/aplikacji, możesz:</p>

  <p>
    Możemy także korzystać z informacji osobowych, które udostępniłeś nam na tej stronie internetowej/w tej aplikacji
    (jak np. imię i nazwisko, email, adres, płeć oraz numer telefonu) w celu zidentyfikowania Cię na Facebooku (lub
    Instagramie, Messengerze lub w innych usługach Facebooka) w celu pokazywania Ci reklam, które jeszcze bardziej będą
    do Ciebie dopasowane. W ramach tej czynności Facebook nie udostępni Twoich danych osobowych oraz usunie je
    natychmiast po zakończeniu procesu dopasowania.
  </p>

  <p><b>Nie oferujemy ani nie sprzedajemy Twoich danych osobowych.</b></p>

  <h2>Gdzie przechowujemy Twoje dane osobowe</h2>

  <p>
    Dane, które pozyskujemy od Ciebie, mogą być przeniesione do lokalizacji znajdującej się poza Europejskim Obszarem
    Gospodarczym („EOG"), z tej lokalizacji możemy uzyskiwać do nich dostęp i w niej mogą być przechowywane. Mogą być
    także przetwarzane przez współpracowników działających poza EOG na naszą rzecz lub na rzecz naszych usługodawców.
  </p>

  <p>
    L’Oréal przekazuje dane osobowe poza EOG wyłącznie w sposób bezpieczny i zgodny z prawem. Ponieważ niektóre państwa
    mogą nie posiadać ustawodawstwa dotyczącego wykorzystywania oraz przekazywania danych osobowych, podejmujemy
    działania w celu zapewnienia, by takie podmioty stosowały się do zobowiązań określonych w niniejszej Polityce. Do
    działań tych należy między innymi analiza standardów dotyczących prywatności i bezpieczeństwa takich podmiotów lub
    zawieranie z nimi odpowiednich umów (w oparciu o wzór przyjęty przez Komisję UE).
  </p>

  <p>
    Aby uzyskać więcej informacji na ten temat prosimy skontaktować się z nami w sposób podany w części „Kontakt”
    poniżej.
  </p>

  <h2>Jak długo przechowujemy Twoje dane osobowe</h2>

  <p>
    Twoje dane osobowe przechowujemy tylko tak długo, jak jest nam to niezbędne w celu, w jakim je przechowujemy, aby
    spełnić Twoje potrzeby lub nasze zobowiązania prawne. Aby ustalić okres zatrzymywania Twoich danych, stosujemy
    następujące kryteria:
  </p>

  <p>
    Możemy zatrzymać niektóre dane osobowe w celu spełnienia naszych zobowiązań prawnych, jak również w celu
    umożliwienia nam zarządzania naszymi prawami (np. w celu dochodzenia praw na drodze sądowej) lub też w celach
    statystycznych bądź historycznych.
  </p>

  <p>
    W przypadku gdy nie ma już potrzeby przechowywania Twoich danych osobowych, są one usuwane z naszych systemów i akt,
    bądź anonimizowane tak, by uniemożliwić Twoją identyfikację.
  </p>

  <h2>Czy Twoje dane osobowe są bezpieczne?</h2>

  <p>
    Jesteśmy zdeterminowani, by przechowywać dane osobowe użytkowników w sposób bezpieczny i w tym celu podejmujemy
    wszystkie racjonalne środki ostrożności. Od zaufanych podmiotów, którym powierzamy czynności związane z danymi
    osobowymi, wymagamy w zawieranych z nimi umowach, by podejmowały te same starania.
  </p>

  <p>
    Zawsze dokładamy najlepszych starań, by chronić dane osobowe użytkowników, i od chwili ich otrzymania stosujemy
    ścisłe procedury i zabezpieczenia w celu zapobiegania dostępowi osób nieuprawnionych. Ponieważ przesyłanie
    informacji przez internet nie jest w 100% bezpieczne, nie możemy zagwarantować bezpieczeństwa danych, które
    użytkownicy udostępniają na naszej stronie. W związku z tym, wszelkie przekazywanie danych odbywa się na ich ryzyko.
  </p>

  <h2>Linki do stron internetowych innych podmiotów oraz Social Login</h2>

  <p>
    Na naszych stronach internetowych/w naszych aplikacjach mogą się czasami znajdować linki do stron internetowych
    sieci naszych partnerów, reklamodawców i podmiotów stowarzyszonych. W przypadku kliknięcia w link do którejkolwiek z
    takich stron, prosimy mieć na uwadze, że na każdej z nich obowiązuje jej własna polityka prywatności, za którą my
    nie ponosimy odpowiedzialności. Prosimy o zapoznanie z taką polityką przed udostępnieniem swoich danych osobowych na
    takiej stronie/aplikacji.
  </p>

  <p>
    Możemy także zaproponować Ci korzystanie z Twojego social media login. Jeśli z niego skorzystasz, pamiętaj, że
    udostępniasz nam informacje ze swojego profilu w zależności od swoich ustawień na platformie mediów
    społecznościowych. Prosimy o odwiedzenie danej platformy mediów społecznościowych i zapoznanie się z jej polityką
    prywatności w zakresie sposobu udostępniania i wykorzystywania Twoich danych osobowych w tym kontekście.
  </p>

  <h2>Media społecznościowe oraz treści generowane przez użytkownika</h2>

  <p>
    Niektóre z naszych stron internetowych/aplikacji pozwalają użytkownikom na udostępnianie ich własnych treści.
    Prosimy pamiętać, że wszelkie treści udostępniane na jednej z naszych platform w mediach społecznościowych mogą być
    przeglądane publicznie, zatem należy zachować ostrożność co do udostępniania pewnych danych osobowych, np.
    informacji finansowych lub adresu. Nie ponosimy odpowiedzialności za działania innych osób, jeżeli umieścisz dane
    osobowe na jednej z naszych platform w mediach społecznościowych, zatem rekomendujemy, by takich informacji tam nie
    umieszczać.
  </p>

  <h2>TWOJE PRAWA I WYBORY</h2>

  <p>
    L’Oréal szanuje Twoje prawo do prywatności: ważne jest, by każdy użytkownik mógł kontrolować swoje dane osobowe.
    Przysługują Ci następujące prawa:
  </p>

  <table>
    <thead>
      <tr>
        <th>Twoje prawa</th>
        <th>Co to oznacza?</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <p>Prawo do uzyskania&nbsp;<b>informacji</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo otrzymania jasnych, przejrzystych i łatwych do zrozumienia informacji na temat sposobu,
            w jaki wykorzystujemy Twoje dane osobowe, oraz na temat przysługujących Ci praw. Właśnie dlatego
            przedstawiamy Ci informacje w ramach niniejszej Polityki.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo&nbsp;<b>dostępu</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo dostępu do danych osobowych, które posiadamy na Twój temat (z zastrzeżeniem pewnych
            ograniczeń). Możemy pobierać opłatę w racjonalnej wysokości stosownie do kosztów administracyjnych
            udzielania informacji. Na prośby w sposób oczywisty nieuzasadnione, nadmierne, powtarzające się możemy nie
            udzielać odpowiedzi.W tym celu skontaktuj się z nami, korzystając z poniższych danych kontaktowych.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>The right to&nbsp;<b>rectification</b></p>
        </td>
        <td>
          <p>
            You have the right to have your personal data rectified if it is incorrect or outdated and/or completed if
            it is incomplete. If you have an account, it may be easier to correct your own personal data via your “My
            Account” function.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo do&nbsp;<b>sprostowania</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo sprostowania Twoich danych osobowych, jeżeli są niepoprawne lub nieaktualne bądź do ich
            uzupełnienia, jeśli są niekompletne. W tym celu skontaktuj się z nami, korzystając z poniższych danych
            kontaktowych. Jeżeli posiadasz konto, łatwiej może być sprostować swoje dane za pośrednictwem funkcji „Moje
            konto”.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo do&nbsp;<b>usunięcia danych/bycia zapomnianym</b></p>
        </td>
        <td>
          <p>
            W niektórych przypadkach przysługuje Ci prawo do usunięcia Twoich danych osobowych. Zwracamy uwagę, że nie
            jest to prawo bezwzględne, gdyż możemy mieć podstawy prawne lub uzasadniony interes w zatrzymaniu Twoich
            danych osobowych. Jeżeli chcesz, byśmy usunęli Twoje dane osobowe, prosimy o kontakt w sposób podany
            poniżej.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo do&nbsp;<b>do cofnięcia w dowolnym czasie zgody na przetwarzanie danych na podstawie zgody</b></p>
        </td>
        <td>
          <p>
            Możesz wycofać udzieloną nam zgodę na przetwarzanie Twoich danych osobowych, jeżeli przetwarzanie odbywa się
            na podstawie zgody. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania dokonywanego na
            podstawie zgody przed jej wycofaniem. Odsyłamy do tabeli znajdującej się w części pt. „Jakie dane osobowe
            gromadzimy na Twój temat oraz jak je wykorzystujemy?”, szczególnie do kolumny „Podstawy prawne wykorzystania
            Twoich danych osobowych” w celu sprawdzenia, w jakich przypadkach przetwarzanie odbywa się na podstawie
            zgody.Jeżeli chcesz wycofać swoją zgodę, prosimy o kontakt w sposób podany poniżej.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo do&nbsp;<b>sprzeciwu wobec przetwarzania na podstawie uzasadnionego interesu</b></p>
        </td>
        <td>
          <p>
            Możesz w dowolnym czasie sprzeciwić się wobec przetwarzania Twoich danych osobowych, gdy przetwarzanie
            odbywa się na podstawie uzasadnionego interesu. Odsyłamy do tabeli znajdującej się w części „Jakie dane
            osobowe gromadzimy na Twój temat oraz jak je wykorzystujemy?”, szczególnie do kolumny „Podstawy prawne
            wykorzystania Twoich danych osobowych” w celu sprawdzenia, w jakich przypadkach przetwarzanie odbywa się na
            podstawie uzasadnionego interesu.W tym celu skontaktuj się z nami, korzystając z danych poniżej.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo&nbsp;<b>złożenia skargi w organie nadzorczym</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo skontaktowania się z organem ds. ochrony danych osobowych w Twoim kraju w celu złożenia
            skargi na praktyki L’Oréal w zakresie ochrony danych i prywatności.
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo&nbsp;<b>do przenoszenia danych</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo żądania ograniczenia przetwarzania przez nas Twoich danych. Oznacza to, że
            przetwarzanie przez nas danych będzie ograniczone w taki sposób, że możemy je przechowywać, ale nie możemy
            ich wykorzystywać albo dalej przetwarzać. Ma to zastosowanie w pewnych okolicznościach wymienionych w
            Rozporządzeniu o ochronie danych osobowych, które są następujące:
          </p>

          <ul>
            <li>
              osoba, której dane dotyczą (tj. Ty), kwestionuje prawidłowość danych osobowych, na okres pozwalający
              administratorowi sprawdzić prawidłowość tych danych;
            </li>
            <li>
              przetwarzanie jest niezgodne z prawem, a osoba, której dane dotyczą (tj. Ty), sprzeciwia się usunięciu
              danych osobowych, żądając w zamian ograniczenia ich wykorzystywania;
            </li>
            <li>
              administrator (tj. L’Oréal) nie potrzebuje już danych osobowych do celów przetwarzania, ale są one
              potrzebne osobie, której dane dotyczą, do ustalenia, dochodzenia lub obrony roszczeń;
            </li>
            <li>
              osoba, której dane dotyczą (tj. Ty), wniosła sprzeciw wobec przetwarzania na podstawie uzasadnionego
              interesu administratora danych – do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie
              administratora są nadrzędne wobec podstaw sprzeciwu osoby, której dane dotyczą.
            </li>
          </ul>

          <p>Jeżeli chcesz poprosić o ograniczenie, prosimy o kontakt w sposób podany poniżej.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Prawo do&nbsp;<b>dezaktywacji plików Cookies</b></p>
        </td>
        <td>
          <p>
            Przysługuje Ci prawo dezaktywacji plików Cookies. Ustawienia z przeglądarek internetowych są zwykle
            domyślnie zaprogramowane tak, by akceptować pliki Cookies, ale możesz to łatwo zmienić przez zmianę ustawień
            w Twojej przeglądarce.
          </p>

          <p>
            Wiele plików cookies jest wykorzystywanych w celu poprawy wartości użytkowej oraz funkcjonalności stron
            internetowych/aplikacji; dlatego też ich dezaktywacja może uniemożliwiać korzystanie z niektórych części
            naszych stron internetowych/aplikacji wymienionych w odpowiedniej tabeli plików Cookies.
          </p>

          <p>
            Jeżeli chcesz ograniczyć lub zablokować wszystkie pliki cookies, które są ustawione przez nasze strony
            internetowe/aplikacje (co może uniemożliwiać Ci korzystanie z niektórych części takich stron) lub inne
            strony/aplikacje, możesz to zrobić w ustawieniach swojej przeglądarki. Funkcja Pomocy w przeglądarce powinna
            opisywać, w jaki sposób można tego dokonać. Więcej informacji znajduje się pod tymi linkami:&nbsp;<a
              href="http://www.aboutcookies.org/"
              >http://www.aboutcookies.org/</a
            >
          </p>
        </td>
      </tr>
    </tbody>
  </table>

  <p><b>Aby spełnić Twoją prośbę, możemy potrzebować dowodu Twojej tożsamości.</b></p>

  <p><b>KONTAKT</b></p>

  <p>
    Jeżeli masz pytania lub wątpliwości co do tego, w jaki sposób postępujemy z Twoimi danymi osobowymi lub chcesz
    skorzystać z któregoś z przysługujących Ci praw wymienionych powyżej, prosimy o kontakt pod adresem:&nbsp;<a
      href="mailto:personal-da&#64;.com"
      >personal-da&#64;.com</a
    >&nbsp;lub napisać do nas na adres:
  </p>

  <ul>
    <li><b>- Twoja zgoda</b></li>
    <li>
      <b>- Wykonywanie umowy:</b>&nbsp;Ma to zastosowanie, gdy udostępniasz nam swoje dane osobowe, gdy mamy dla Ciebie
      wykonać jakąś usługę (np. gdy prosisz nas o stworzenie konta klienta lub gdy zamierzasz kupić produkt, a my możemy
      zająć się związaną z tym logistyką).
    </li>
    <li>
      <b>- Nasz prawnie uzasadniony interes</b>, którym może być:
      <ol>
        <li>
          doskonalenie naszych produktów i usług: a konkretnie nasz interes gospodarczy, by lepiej zrozumieć Twoje
          potrzeby i oczekiwania i w związku z tym doskonalenie naszych usług, stron internetowych/aplikacji, urządzeń,
          produktów oraz marek na rzecz naszych Klientów;
        </li>
        <li>zapobieganie oszustwom: w celu zapewnienia pełnej płatności wolnej od oszustwa i sprzeniewierzenia;</li>
        <li>
          zabezpieczenie naszych narzędzi: zapewnienie bezpieczeństwa używanych przez Ciebie narzędzi (nasze strony
          internetowe/aplikacje, urządzenia) oraz zapewnienie ich sprawnego funkcjonowania i stałego doskonalenia.
        </li>
      </ol>
    </li>
    <li>
      <b>- Podstawy prawne:</b>&nbsp;Gdy musimy przechowywać Twoje dane osobowe ze względów prawnych (np. gdy dokonujesz
      zakupu, musimy zachować informacje o Twojej transakcji, aby spełnić obowiązki z zakresu sprawozdawczości
      podatkowej i finansowej).
      <ul>
        <li>
          - podmiotom zewnętrznym pomagającym nam w świadczeniu usług cyfrowych oraz usług z zakresu handlu
          elektronicznego, takich jak social listening, lokalizator sklepów, programy lojalnościowe, zarządzanie
          tożsamością, przeglądanie mediów społecznościowych oraz profili publicznych, oceny i recenzje, CRM, analizy
          sieci oraz wyszukiwarki, narzędzia do przechowywania treści generowanych przez użytkowników;
        </li>
        <li>
          - agencjom reklamowym, marketingowym, cyfrowym i agencjom ds. mediów społecznościowych, które pomagają nam w
          tworzeniu reklamy, marketingu oraz kampanii, w analizie ich efektywności, a także w zarządzaniu kontaktami z
          użytkownikami, ich pytaniami oraz łączącymi nas relacjami;
        </li>
        <li>- podmiotom, które zajmują się dostawą produktów do klienta, np. poczcie/kurierowi;</li>
        <li>
          - podmiotom, które pomagają nam w świadczeniu usług IT, takim jak dostawcy platform, dostawcy usług
          hostingowych, dostawcy zajmujący się utrzymaniem i wsparciem naszych baz danych oraz oprogramowania i
          aplikacji, które mogą zawierać Twoje dane (takie usługi mogą czasami wiązać się z dostępem do Twoich danych w
          celu wykonania wymaganych zadań);
        </li>
        <li>
          - dostawcom usług płatniczych oraz agencjom informacji kredytowej w celu oceny Twojej wiarygodności kredytowej
          oraz sprawdzenia Twoich danych w przypadku gdy stanowi to warunek zawarcia między nami umowy;
        </li>
        <li>
          - podmiotom zewnętrznym, które wspierają nas w obsłudze klienta oraz w zakresie nadzoru nad bezpieczeństwem
          produktów kosmetycznych;
        </li>
        <li>
          - podmiotom, które pomagają nam w organizacji szkoleń, seminariów, imprez, takim jak firmy szkoleniowe,
          agencje podróży, firmy specjalizujące się w imprezach masowych; lub
        </li>
        <li>
          - podmiotom, które świadczą dla nas usługi doradcze w zakresie badań i analiz rynkowych, gromadzenia
          informacji zwrotnej, prowadzenia badań rynkowych dotyczących naszych produktów, usług oraz generalnie w celach
          zarządzania relacjami z klientem.
        </li>
      </ul>

      <ul>
        <li>
          - W przypadku gdybyśmy sprzedawali nasze przedsiębiorstwo lub składniki majątkowe, udostępnimy dane osobowe
          użytkowników potencjalnemu nabywcy przedsiębiorstwa lub składników majątkowych. W przypadku gdy L’Oréal lub
          część jego składników majątkowych zostanie nabyta przez inny podmiot, przechowywane przez nas dane osobowe
          dotyczące klientów, a związane z takimi składnikami majątkowymi zostaną zbyte wraz z nimi. W stosownych
          przypadkach, jeżeli taka sytuacja będzie mieć miejsce, nabywca działający jako nowy administrator danych
          będzie przetwarzać Twoje dane osobowe i w tym zakresie będzie mieć zastosowanie jego polityka prywatności.
        </li>
        <li>
          - Jeżeli będziemy zobowiązani do ujawnienia Twoich danych osobowych w celu spełnienia obowiązku prawnego lub w
          celu wyegzekwowania lub zastosowania naszych warunków użytkowania lub sprzedaży bądź innych warunków, na które
          wyraziłeś zgodę; lub też w celu ochrony praw, mienia lub zapewnienia bezpieczeństwa L’Oréal, naszych klientów
          lub pracowników.
        </li>
        <li>- O ile posiadamy Twoją zgodę na takie czynności.</li>
        <li>- Lub jeśli zezwala nam na to prawo.</li>
      </ul>

      <ul>
        <li>- przez L’Oréal zgodnie z niniejszą Polityką Prywatności;</li>
        <li>
          - przez partnera działającego także jako administrator danych zgodnie z jego własnymi warunkami oraz zgodnie z
          jego własną polityką prywatności.
        </li>
      </ul>

      <ul>
        <li>
          - Zapisać się, wpisując własny login z Facebooka. Jeżeli to zrobisz, będzie to równoznaczne z udzieleniem
          zgody na udostępnienie nam niektórych informacji z Twojego publicznego profilu;
        </li>
        <li>
          - Korzystać z wtyczek społecznościowych Facebooka, takich jak „lubię to” lub „udostępnij” w stosunku do
          naszych treści na platformie Facebook;
        </li>
        <li>
          - Akceptować pliki cookies z tej strony/aplikacji (także identyfikowanych jako „Facebook Pixel”), które pomogą
          nam zrozumieć Twoją aktywność, w tym informacje na temat Twojego urządzenia, sposobu korzystania z naszych
          usług, dokonywanych przez Ciebie zakupów, oglądanych reklam, tego, czy posiadasz konto na Facebooku oraz czy
          jesteś zalogowany na Facebooku. Gdy korzystasz z funkcji Facebooka, gromadzimy dane, które pomagają nam:
          <ul>
            <li>
              - pokazywać Ci reklamy, które mogą Cię interesować na Facebooku (lub Instagramie, Messengerze lub w innych
              usługach Facebooka);
            </li>
            <li>- mierzyć i analizować skuteczność naszych stron internetowych/aplikacji i reklam</li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          - Gdy kupujesz produkty i usługi, przechowujemy Twoje dane osobowe przez okres trwania naszych stosunków
          umownych;
        </li>
        <li>
          - Gdy bierzesz udział w ofercie promocyjnej, przechowujemy Twoje dane osobowe przez okres obowiązywania oferty
          promocyjnej;
        </li>
        <li>
          - Gdy kontaktujesz się z nami, by nam zadać pytanie, przechowujemy Twoje dane osobowe przez czas niezbędny do
          przetwarzania takiego zapytania;
        </li>
        <li>
          - Gdy utworzysz sobie konto, przechowujemy Twoje dane osobowe, dopóki nie poprosisz nas o ich usunięcie lub do
          upływu pewnego okresu nieużywania go (braku czynnej interakcji z markami) zdefiniowanego zgodnie z lokalnymi
          przepisami i wytycznymi;
        </li>
        <li>
          - Gdy wyrażasz zgodę na marketing bezpośredni, przechowujemy Twoje dane osobowe, dopóki się nie wypiszesz lub
          dopóki nie poprosisz nas o ich usunięcie, lub też do upływu pewnego okresu bezczynności (braku czynnej
          interakcji z markami) zdefiniowanego zgodnie z lokalnymi przepisami i wytycznymi;
        </li>
        <li>
          - Gdy na Twoim komputerze znajdują się pliki cookies, przechowujemy je tak długo, jak jest to konieczne w celu
          osiągnięcia ich celów (np. na czas sesji w przypadku plików cookies dotyczących koszyka zakupów lub cookies
          dotyczących ID sesji) oraz przez okres zdefiniowany w lokalnych przepisach i wytycznych.
        </li>
      </ul>
    </li>
    <li>
      L’Oréal Polska Sp. z o.o.<br />
      Ul. Grzybowska 62<br />
      00-844 Warszawa<br />
      Polska
      <p>&nbsp;</p>

      <p>
        Możesz także skontaktować się z naszym Inspektorem Ochrony Danych pod adresem:&nbsp;<a
          href="mailto:personal-da@.com"
          >personal-da&#64;.com</a
        >.
      </p>
    </li>
  </ul>
</div>
